(() => {
  const records = new Map();
  const mobile = matchMedia('(max-width: 749px)'), reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function current(record) {
    const slide = record.root.closest('[data-wr-slide]');
    return !slide || slide.classList.contains('is-active');
  }
  function update(record) {
    const root = record.root;
    const allowed = record.visible && !document.hidden && current(record);
    if (!allowed) { record.video?.pause(); return; }
    if (mobile.matches && root.querySelector('[data-mobile-still]')) { record.video?.pause(); return; }
    if (!record.video) {
      if (window.Shopify?.designMode) return;
      const template = (mobile.matches && root.querySelector('[data-video-mobile]')) || root.querySelector('[data-video-desktop]');
      if (!template) return;
      root.append(template.content.cloneNode(true));
      record.video = root.querySelector('video');
      record.video?.addEventListener('playing', () => root.classList.add('is-playing'));
    }
    if (!reduced.matches && !navigator.connection?.saveData) record.video?.play().catch(() => {});
  }
  const observer = new IntersectionObserver(entries => {
    for (const entry of entries) { const r = records.get(entry.target); if (r) { r.visible = entry.isIntersecting; update(r); } }
  }, { threshold: 0.05 });
  function scan(scope = document) {
    scope.querySelectorAll('[data-plush-video]').forEach(root => {
      if (records.has(root)) return;
      const record = { root, video: null, visible: false };
      const slide = root.closest('[data-wr-slide]');
      if (slide) { record.mutation = new MutationObserver(() => update(record)); record.mutation.observe(slide, { attributes: true, attributeFilter: ['class'] }); }
      records.set(root, record); observer.observe(root);
    });
  }
  document.addEventListener('visibilitychange', () => records.forEach(update));
  mobile.addEventListener('change', () => records.forEach(record => {
    if (record.video) { record.video.pause(); record.video.remove(); record.video = null; record.root.classList.remove('is-playing'); }
    update(record);
  }));
  reduced.addEventListener('change', () => records.forEach(record => { if (reduced.matches) record.video?.pause(); else update(record); }));
  document.addEventListener('shopify:section:load', event => scan(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [root, record] of records) if (event.target.contains(root)) { record.video?.pause(); record.mutation?.disconnect(); observer.unobserve(root); records.delete(root); }
  });
  document.addEventListener('shopify:block:select', event => {
    const slide = event.target.closest('[data-wr-slide]');
    if (slide) slide.closest('[data-wr-viewport]')?.querySelector(`[data-wr-dot="${slide.dataset.index}"]`)?.click();
  });
  scan();
})();
